export const ROLES = ["Administrador", "Almacén", "Producción", "Reparto", "Ventas"];

export const PIECEWORK_TYPES = [
  { value: "tinaco_1100", label: "Tinaco 1100 litros" },
  { value: "tinaco_3200", label: "Tinaco 3200 litros" },
  { value: "tinaco_5200", label: "Tinaco 5200 litros" },
];

export const ROLE_TABS = {
  Administrador: ["dashboard", "catalog", "production", "users", "sales", "delivery", "admin"],
  "Almacén": ["dashboard","catalog"],
  "Producción": ["production"],
  Reparto: ["dashboard", "delivery"],
  Ventas: ["dashboard", "sales"],
};

export const hasRoleAccess = (role, tab) => ROLE_TABS[role]?.includes(tab) || false;